module.exports = __webpack_public_path__ + "arrow-up.dffc56bbb9e68d6bae6f.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/arrow-up.svg
// module id = ../../../../../src/img/icon/arrow-up.svg
// module chunks = styles